import React, { Fragment } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { LiveProducts } from '../../../Constant';
import { ProductData } from '../../../Data/Widgets/Chart/ChartData';

const LiveProductionChart = () => {
  return (
    <Fragment>
      <Col xl='7' lg='12' className='xl-50'>
        <div className='small-chart-widget chart-widgets-small'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{LiveProducts}</H5>
            </CardHeader>
            <CardBody>
              <div className='chart-container'>
                <Row>
                  <Col xs='12'>
                    <div id='chart-widget6'>
                      <ReactApexChart options={ProductData.options} series={ProductData.series} height='320' type='line' />
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
    </Fragment>
  );
};
export default LiveProductionChart;
